import React from "react";
import PropTypes from "prop-types";
import CarouselNav from "components/dashboard/CarouselNav";
import { injectIntl, intlShape } from "react-intl";

const renderItem = (item, id) => (
  <div key={item.title ? item.title : `acme${id}`}>
    <iframe
      src={item.url}
      width="550"
      height="309"
      frameBorder="0"
      allowFullScreen=""
      title={item.title ? item.title : null}
    />
  </div>
);

class DashboardVideos extends React.Component {
  state = {
    currIdx: 0,
  };

  onSelect = idx => {
    const max = this.props.items ? this.props.items.length : 0;
    const currIdx = (idx % max + max) % max;

    this.setState({
      currIdx,
    });
  };

  render() {
    const items = this.props.items;

    if (!items.length) {
      return null;
    }

    const { currIdx } = this.state;
    const { formatMessage } = this.props.intl;
    const item = items[currIdx];
    return (
      <article className="card">
        <header>
          <h2>
            {formatMessage({ id: item.title, defaultMessage: item.title })}
          </h2>
        </header>
        <section>
          {item && renderItem(item, currIdx)}
        </section>
        <footer>
          {items.length > 1 &&
            <CarouselNav
              noOfItems={items.length}
              onSelect={this.onSelect}
              currIdx={currIdx}
            />}
        </footer>
      </article>
    );
  }
}

DashboardVideos.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  intl: intlShape.isRequired,
};

export default injectIntl(DashboardVideos);



// WEBPACK FOOTER //
// ./components/dashboard/widgets/DashboardVideos.js